import "./Title.scss";

function Title(props) {
    return (
        <div className="title-container">{props.title}</div>
    )
}

export default Title;